export default __webpack_public_path__ + "static/media/sensor_r.04b76922.svg";